import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#problem", label: "The Problem" },
  { href: "#features", label: "Features" },
  { href: "#how", label: "How It Works" },
  { href: "#app", label: "Inside the App" },
  { href: "#download", label: "Download" },
  { href: "#faq", label: "FAQ" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all ${
        scrolled
          ? "backdrop-blur-xl bg-[#F9F8F6]/90 border-b border-[#D5D1C8]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2.5"
        >
          <span
            role="img"
            aria-label="Arvo"
            className="block h-11 w-11 rounded-full bg-[#F9F8F6] shadow-sm bg-no-repeat bg-center bg-contain"
            style={{
              backgroundImage: "url('/screens/logo-cow.png')",
            }}
          />
          <span className="font-display text-xl font-bold tracking-tight text-[#1A1D1A]">
            arvo
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-[#4A4F4A] hover:text-[#2D4A22] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button
            asChild
            data-testid="nav-request-demo"
            className="bg-[#D96C32] hover:bg-[#B85A28] text-white font-bold rounded-md px-5 py-2 h-auto shadow-sm"
          >
            <a href="#cta">Request a Demo</a>
          </Button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden inline-flex items-center justify-center w-11 h-11 rounded-md text-[#1A1D1A]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#D5D1C8] bg-[#F9F8F6]/95 backdrop-blur-xl">
          <div className="px-4 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="py-2 text-base font-medium text-[#1A1D1A]"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="mobile-request-demo"
              className="bg-[#D96C32] hover:bg-[#B85A28] text-white font-bold rounded-md mt-2"
            >
              <a href="#cta" onClick={() => setOpen(false)}>
                Request a Demo
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
